import { render, staticRenderFns } from "./BonusContentList.vue?vue&type=template&id=3b35e200&scoped=true"
import script from "./BonusContentList.vue?vue&type=script&lang=js"
export * from "./BonusContentList.vue?vue&type=script&lang=js"
import style0 from "./BonusContentList.vue?vue&type=style&index=0&id=3b35e200&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b35e200",
  null
  
)

export default component.exports